import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Globe2 } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-[#0A1E2D] text-slate-300 overflow-hidden">
      <div className="absolute -top-32 -right-32 h-72 w-72 rounded-full bg-[#F26F21]/10 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-40 -left-40 h-96 w-96 rounded-full bg-[#0E2A3F] blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="relative flex h-11 w-11 items-center justify-center rounded-lg bg-white/10 text-white">
                <Globe2 className="h-5 w-5" strokeWidth={1.8} />
                <span className="absolute -bottom-1 -right-1 h-3 w-3 rounded-full bg-[#F26F21] ring-2 ring-[#0A1E2D]" />
              </span>
              <div>
                <div className="text-[10px] uppercase tracking-[0.22em] text-[#F26F21] font-semibold">Global Trade</div>
                <div className="font-[Outfit] font-bold text-white text-lg leading-tight">VRVR Import &amp; Exports</div>
              </div>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-slate-400">
              Your Trusted Partner in Global Trade — connecting markets across continents with
              reliable import, export and consulting solutions.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-white font-semibold text-sm uppercase tracking-[0.18em] mb-5">Explore</h4>
            <ul className="space-y-3 text-sm">
              {[
                { to: "/", label: "Home" },
                { to: "/about", label: "About Us" },
                { to: "/services", label: "Services" },
                { to: "/contact", label: "Contact" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-slate-300 hover:text-[#F26F21] transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-white font-semibold text-sm uppercase tracking-[0.18em] mb-5">Get in Touch</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <Mail className="h-4 w-4 mt-0.5 text-[#F26F21]" />
                <a href="mailto:mahender@vrvr.in" className="hover:text-white transition-colors">
                  mahender@vrvr.in
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="h-4 w-4 mt-0.5 text-[#F26F21]" />
                <div className="space-y-1">
                  <div>+27 747 857 141</div>
                  <div>+91 8977 109 231</div>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 mt-0.5 text-[#F26F21]" />
                <span className="leading-relaxed">
                  4-2-608, Ramkoti, Sultan Bazar,<br />
                  Hyderabad, Telangana, India
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} VRVR Import and Exports. All rights reserved.</div>
          <div className="hidden sm:block">Built for global commerce.</div>
        </div>
      </div>
    </footer>
  );
}
